export default __webpack_public_path__ + "static/media/penhole-reps_converted.777dbf5d.jpg";